module.exports = __webpack_public_path__ + "static/data-structures-and-algorithms-1ba32158a8318122679cf54badd76b35.png";